import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  asyncGetItem,
  asyncGetList,
} from "@/setup/flexbiz-api-provider/coreFunction";
import newsKeys from "../queryKeys/newsKeys";

const DEFAULT_STALE_TIME = 60000; // 1min

export const fetchNewsArticle = async (slug: string, locale = "vi") => {
  return await asyncGetList<any[]>({
    collection_name: "news",
    options: {
      condition: {
        isnews: true,
        shared: true,
        slug,
        ngon_ngu: locale,
      },
    },
  });
};

export const useFetchNewsArticle = (slug: string, locale = "vi") => {
  return useQuery({
    queryKey: newsKeys.detail(slug, locale),
    queryFn: () => fetchNewsArticle(slug, locale),
    staleTime: DEFAULT_STALE_TIME,
    enabled: !!slug,
  });
};

/* -------------------------------------------------------------------------- */

export const fetchNewsArticles = async (options: any = {}) => {
  const locale = options?.condition?.ngon_ngu || "vi";
  return await asyncGetList<any[]>({
    collection_name: "news",
    options: {
      page: 1,
      limit: process.env.NEWS_LOADING_LIMIT,
      sort: {
        date_created: -1,
      },
      ...options,
      condition: {
        isnews: true,
        ngon_ngu: locale,
        shared: true,
        loai_tin_tuc: { $in: ["Tin tức Dragon Home", "Tin tức DRAGON HOME"] },
        ...(options?.condition || {}),
      },
    },
  });
};

export const useFetchNewsArticles = (options: any) => {
  return useQuery({
    queryKey: newsKeys.list(options),
    queryFn: () => fetchNewsArticles(options),
    enabled: !!options,
    staleTime: DEFAULT_STALE_TIME,
  });
};

/* -------------------------------------------------------------------------- */

export const fetchNewsArticlesCount = async (options: any = {}) => {
  const locale = options?.condition?.ngon_ngu || "vi";
  const data = await asyncGetList<{ rows_number: number }>({
    collection_name: "news",
    options: {
      ...options,
      count: true,
      condition: {
        ngon_ngu: locale,
        isnews: true,
        shared: true,
        loai_tin_tuc: { $in: ["Tin tức Orapark"] },
        ...(options?.condition || {}),
      },
    },
  });
  return data?.rows_number || 0;
};

export const useFetchNewsArticlesCount = (options: any) => {
  return useQuery({
    queryKey: newsKeys.count(options || {}),
    queryFn: () => fetchNewsArticlesCount(options),
    enabled: !!options,
    staleTime: DEFAULT_STALE_TIME,
  });
};
